import { Appointment } from 'vl-common/src/schemas/shared';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import { useEffect } from 'react';

type AppointmentStats = ReturnType<ReturnType<typeof actions.getAppointmentStatus>>;

type AppointmentStatsOptions = Omit<UseQueryOptions<AppointmentStats, Error, AppointmentStats>, 'queryKey' | 'queryFn'>;

export function useAppointmentStats(appointment: Appointment, opts: AppointmentStatsOptions = {}) {
  const dispatch = useDispatch();
  // get the appointment status *after* the viable call window has closed
  const { data, refetch } = useQuery({
    queryKey: ['useAppointmentStatus', appointment.appointment_id],
    queryFn: () => dispatch(actions.getAppointmentStatus(appointment.appointment_id)),
    ...opts
  });

  // reload the appointment status after the viable call window has passed
  useEffect(() => {
    const now = new Date();

    // if the call end is in the future, i.e. still startable, then wait until the call ends
    if (appointment.end > now) {
      const timeout = setTimeout(() => refetch(), appointment.end.getTime() - now.getTime());

      return () => clearTimeout(timeout);
    }

    return () => {};
  }, []);

  return data;
}

export function useMissedVideoCall(appointment: Appointment) {
  const data = useAppointmentStats(appointment, { enabled: () => new Date() > appointment.end });

  if (!data) {
    return false;
  }

  const { clin_start } = data.appointment_stati[0];

  if (clin_start) return false;

  return appointment.end < new Date();
}
